import { ArrowLeftOutlined } from '@ant-design/icons';
import { useState } from 'react';
import PreViewComponent from '../TinTucDetailPage/ImagePopupSlideshow';
import { BASE_FILE_URL } from '@/common/constants';

function DetailContent({ selectedMedia, setOpenNewPage }) {
  const [showImagePopup, setShowImagePopup] = useState(false);

  const handleImageClick = () => {
    setShowImagePopup(true);
  };

  const renderLongforms = () => {
    if (selectedMedia?.medias?.length > 1) {
      return <PreViewComponent content={selectedMedia?.title} fontSize={16} listImg={selectedMedia?.medias} mediaContent />;
    } else {
      return (
        <div
          className="text-md content-articles ck ck-content ck-editor__editable 
          ck-rounded-corners ck-editor__editable_inline ck-blurred !overflow-y-hidden"
          dangerouslySetInnerHTML={{ __html: selectedMedia?.title ?? '' }}
        />
      );
    }
  };

  const renderInfographics = () => {
    return (
      <div className="space-y-4">
        {/* Content description */}
        {selectedMedia?.content && (
          <div
            className="text-md content-articles ck ck-content ck-editor__editable 
            ck-rounded-corners ck-editor__editable_inline ck-blurred !overflow-y-hidden mb-6"
            dangerouslySetInnerHTML={{ __html: selectedMedia.content }}
          />
        )}

        {/* Images list */}
        <div className="space-y-3">
          {selectedMedia?.fileUrls?.map((imageUrl, index) => (
            <div key={index} className="relative">
              <img
                src={`${BASE_FILE_URL}/${imageUrl}`}
                alt={`Infographic ${index + 1}`}
                className="w-full h-auto rounded-lg shadow-sm cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => handleImageClick()}
              />
              <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-xs">
                {index + 1}/{selectedMedia.fileUrls.length}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const [zoomed, setZoomed] = useState(false);

  const handleClose = () => {
    setShowImagePopup(false);
  };

  const handleZoomToggle = (e) => {
    e.stopPropagation(); // Không để click lan ra ngoài và đóng modal
    setZoomed(!zoomed);
  };
  const renderImagePopup = () => {
    if (!showImagePopup || !selectedMedia?.fileUrls) return null;

    return (
      <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center cursor-pointer" onClick={handleClose}>
        <div className="overflow-y-auto w-full max-h-[90vh] cursor-default ">
          <div className="flex justify-between items-center mb-4">
            <button onClick={handleZoomToggle} className="fixed top-2 right-2 text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600">
              {zoomed ? 'Thu nhỏ' : 'Phóng to'}
            </button>
          </div>

          <div className="space-y-6">
            {selectedMedia.fileUrls.map((imageUrl, index) => (
              <div key={index} className="relative">
                <img
                  src={`${BASE_FILE_URL}/${imageUrl}`}
                  alt={`Infographic ${index + 1}`}
                  className={`
                  transition-all duration-500 ease-in-out shadow-md mx-auto
                  ${zoomed ? 'w-full h-auto object-contain' : 'max-h-[80vh] w-auto object-contain'}
                `}
                />
                <div className="absolute bottom-1 right-1 bg-black bg-opacity-50 text-white px-1 py-0.5 rounded text-xs">{index + 1}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      {/* Header với nút Back và tên media */}
      <div className="flex items-center gap-3 px-6 py-4 border-b">
        <button
          onClick={() => setOpenNewPage(false)}
          className="flex items-center text-xl font-semibold text-gray-800 truncate transition cursor-pointer">
          <ArrowLeftOutlined className="text-lg" />
          <span className="ml-2 font-medium">{selectedMedia?.name}</span>
        </button>
      </div>

      {/* Nội dung chính */}
      <div className={`${selectedMedia?.type === 'longforms' ? '' : 'w-[60%]'} mx-auto py-6`}>
        {selectedMedia?.type === 'longforms' ? renderLongforms() : renderInfographics()}
      </div>

      {/* Image Popup cho infographics */}
      {selectedMedia?.type === 'infographics' && renderImagePopup()}
    </div>
  );
}

export default DetailContent;
